import React from 'react';
import classnames from 'classnames';
import PropTypes from 'prop-types';

import { useDefaultStyles } from '@bingads-webui-react/with-default-styles';

import { getCallToActionStyles } from './styles/call-to-action';

export const CallToAction = ({
  actionText,
  dismissText,
  styleOverrides,
}) => {
  const classes = useDefaultStyles(getCallToActionStyles({ styleOverrides }));

  return (
    <React.Fragment>
      <button className={classnames('action-button', classes.actionButton)}>
        {actionText}
      </button>
      {
        dismissText &&
        <button className={classnames('dismiss-button', classes.dismissButton)}>
          {dismissText}
        </button>
      }
    </React.Fragment>
  );
};

CallToAction.propTypes = {
  actionText: PropTypes.string.isRequired,
  dismissText: PropTypes.string,
  styleOverrides: PropTypes.shape({}),
};

CallToAction.defaultProps = {
  dismissText: '',
  styleOverrides: {},
};
